import betaAuthor from '@/assets/author-badges/beta-author.png'

/** Плашка «Экспериментальный доступ»: что закрыто, пока у автора нет полного
 *  доступа. Одна на окно публикации и на режим продажи — выглядят одинаково. */
export const ExperimentalNote = ({ title, body }: { title: string; body: string }) => (
  <div className="flex items-start gap-3 rounded-2xl bg-success/10 p-4 text-sm">
    {/* Тот же значок «Бета-автор», что у ника в меню профиля */}
    <img
      src={betaAuthor}
      alt=""
      draggable={false}
      className="size-7 shrink-0 rounded-[22%] object-cover"
    />
    <div className="space-y-1">
      <div className="font-medium text-success">{title}</div>
      <p className="text-muted-foreground">{body}</p>
    </div>
  </div>
)
